<template>
  <div class="imprint-wrapper">
    <div id="navbar" :class="{ backgroundi: show }">
      <div class="nav-brand" data-aos="zoom-in" data-aos-duration="1500">
        <router-link to="/" data-aos="zoom-in" data-aos-duration="1500">
          <img style="height: 50px" src="../assets/new-logo.svg" alt="" />
        </router-link>
        <b-icon-list scale="2" class="fa fa-navicon" v-on:click="display"></b-icon-list>
      </div>

      <div class="bar-items" :class="{ hide: !show }">
        <div id="menu" data-aos="zoom-in" data-aos-duration="1500">
          <RouterLink to="/">{{$t("Home")}}</RouterLink>

          <RouterLink to="/services">{{$t("Services")}}</RouterLink>

          <RouterLink to="/aboutUs">{{$t("About")}}</RouterLink>

          <RouterLink to="/contact">{{$t("Contact")}}</RouterLink>
          <div class="language-selector">
            <b-dropdown id="dropdown" drop color="black">
              <template #button-content>
                <b-icon icon="globe" style="width:25px; height:30px;"></b-icon>
              </template>
              <b-dropdown-item @click="changeL('de')">Deutsch</b-dropdown-item>
              <b-dropdown-item @click="changeL('en')">English</b-dropdown-item>
              <b-dropdown-item @click="changeL('fr')">French</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid imprint-main-text">
      <h1 class="text-center mb-5">{{ $t('Imprint') }}</h1>
      <h3 class="fw-normal">DS Logistik</h3>
      <h3 class="fw-normal">Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland</h3>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters(["getLanguage"]),
    language() {
      if (this.getLanguage === "en") {
        return "English";
      } else if (this.getLanguage === "de") {
        return "Deutsch";
      } else if (this.getLanguage === "it") {
        return "Italian";
      } else if (this.getLanguage === "fr") {
        return "French";
      }
      return "Shqip";
    },
  },
  methods: {
    ...mapActions(["changeLanguage"]),

    changeL(lang) {
      this.changeLanguage(lang);
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang;
      }
    },

    display() {
      this.show = !this.show;
    },
  },
  name: "Imprint"
}
</script>

<style scoped>
@import "../assets/style/service.scss";
.imprint-wrapper {
  font-family: 'Poppins', sans-serif;
}
.imprint-main-text{
  margin: 180px 0;
}
#navbar {
  background-color: #112432 !important;
  padding: 15px 0;
}
.fa.fa-navicon {
  display: none;
}

.content p {
  text-align: center;
  font: normal normal normal 25px/33px Poppins;
  letter-spacing: -1.25px;
  color: #ffffff;
  opacity: 1;
}
.button button {
  width: 297px;
  height: 53px;
  /* UI Properties */
  background: #008eff 0% 0% no-repeat padding-box;
  opacity: 1;
  /* UI Properties */
  font: normal normal bold 19px/26px Poppins;
  letter-spacing: 0.38px;
  color: #ffffff;
  /* margin-left: 230px; */
  margin-top: 10px;
}

nav {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 10px;
}

nav ul li {
  list-style-type: none;
  display: inline-block;
  padding: 10px 20px;
}

nav ul li a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}
@media screen and (max-width: 1741px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 1441px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 1200px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 1100px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 900px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 768px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media (max-width: 780px) {
  .b-icon.bi {
    display: inline-block;
  }
  #navbar {
    flex-direction: column;
  }
  .backgroundi {
    background-color: rgb(99, 99, 99) !important;
  }
  .fa {
    display: block;
    padding: 0 25px;
    position: absolute;
    right: 0;
    color: #fff;
    font-size: 30px;
    cursor: pointer;
    margin-top: 30px;
  }

  #menu {
    flex-direction: column;
    padding: 5px 0;
  }

  a {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
  }

  .hide {
    display: none;
  }

  .nav-brand {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 15px 0px; */
  }
}
@media screen and (max-width: 568px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 430px) {
  ul {
    text-align: center;
    background-color: black;
  }
}

#navbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: transparent;
  width: 100%;
}

#menu {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: 0 !important;
  padding: 0;
  /* margin-bottom: -24px; */
  margin-top: 30px;
}

a {
  padding: 20px;
}

li:hover {
  background-color: #42d392;
}

a {
  text-decoration: none;
  font-size: 18px;
  color: #fff !important;
  white-space: nowrap;
}

.fa {
  display: none;
}

@media screen and (max-width: 415px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 390px) {
  .b-icon.bi {
    display: inline-block;
  }
}
</style>
